export default __webpack_public_path__ + "static/log-group-ee64b76efe46676f8ff0dff0dc879879.png";